import {QUILL_TAGS} from '@/utils/macros'
import he from 'he'

/** Class EncodeQuill */
export default class EncodeQuill {
  /**
   * Encoding HTML code to header data
   * @param {String} data - HTML data
   * @returns {String} - encoded data
   */
  editor (data) {
    for (let i in QUILL_TAGS.DECODED) {
      const re = new RegExp('<' + QUILL_TAGS.DECODED[i] + '>|</' + QUILL_TAGS.DECODED[i] + '>')
      data = this.replaceTags(data, re, QUILL_TAGS.ENCODED[i])
    }
    const center_tag = '<p class="ql-align-center">'
    const text_between_tags = new RegExp(center_tag)
    let match
    while ((match = text_between_tags.exec(data)) !== null) {
      const center_finish_tag = new RegExp('</p>')
      const string_1 = match.input.slice(0, match.index)
      let string_2 = match.input.slice(match.index)
      string_2 = string_2.replace(center_tag, '&c')
      string_2 = string_2.replace(center_finish_tag, '&c</p>')
      data = string_1 + string_2
    }
    return this.prepareData(data)
  }

  /**
   * Prepare data to send
   * @param {String} data - encoded data
   * @returns {string|*} - data without useless tags
   */
  prepareData (data) {
    data = this.replaceTags(data, '</p>', String.fromCharCode(10))
    data = this.replaceTags(data, '<[\\s\\S]*?>', '')
    data = this.replaceTags(data, '&amp;', '&&')
    // REPLACE FROM &NBSP to white space - is obligatory as it is destroying cash register - DO NOT REMOVE!!!
    data = he.decode(data).replace(/\u00A0/g, ' ')
    data = this.removeDuplicatedTags(data)
    data = data.slice(0, -1) // delete last character LF from data as it is creating new line in cash register
    return data
  }

  /**
   * Replace HTML tags to special encoded characters
   * @param {String} data - HTML data
   * @param {String|RegExp} search - HTML tag
   * @param {String} replacement - encoded character
   * @returns {String} - data with encoded tags
   */
  replaceTags (data, search, replacement) {
    return data.replace(new RegExp(search, 'g'), replacement)
  }

  /**
   * Remove duplicated tags
   * @param {String} data - encoded data
   * @returns {String} - encoded data without duplicates
   */
  removeDuplicatedTags (data) {
    const customTagsAmount = 8
    for (let index = 0; index < customTagsAmount; index++) {
      const indices = []
      for (let character in data) {
        const tag = data.substr(character, 2)
        if (tag === `&${index + 1}`) {
          indices.push(character)
        }
      }
      // remove first and last index
      indices.shift()
      indices.pop()
      let diff = 0
      for (let i of indices) {
        i = parseInt(i)
        const tagIndex = i + diff
        if (data[tagIndex - 1] !== '&') {
          data = data.substr(0, tagIndex) + data.substring(tagIndex + 2, data.length)
          diff -= 2
        }
      }
    }
    return data
  }
}
